"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactToastify = require("react-toastify");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalGeneric = _interopRequireDefault(require("../ModalGeneric/ModalGeneric"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ToastNotification = function ToastNotification(_ref) {
  var toast = _ref.toast,
      options = _ref.options;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var showFullMessage = function showFullMessage(message) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, message, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "button-toast"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setOpenModal(function (oldState) {
          return !oldState;
        });
      }
    }, "Ver detalle")));
  };

  (0, _react.useEffect)(function () {
    if (toast) {
      switch (toast.type) {
        case 'INFO':
          _reactToastify.toast.info(toast.message, options);

          break;

        case 'ERROR':
          _reactToastify.toast.error(toast.fullMessage ? showFullMessage(toast.message) : toast.message, options);

          break;

        case 'SUCCESS':
          _reactToastify.toast.success(toast.message, options);

          break;

        case 'WARNING':
          _reactToastify.toast.warning(toast.message, options);

          break;

        case 'DARK':
          _reactToastify.toast.dark(toast.message, options);

          break;

        default:
          break;
      }
    }
  }, [toast]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, {
    className: "toast-container"
  }), openModal && /*#__PURE__*/_react.default.createElement(_ModalGeneric.default, {
    infoModal: true,
    title: "Detalle error",
    show: openModal,
    onHide: function onHide() {
      return setOpenModal(function (oldState) {
        return !oldState;
      });
    },
    size: "md",
    animation: false,
    backdrop: "static",
    secondaryActionLabel: "Cerrar",
    secondaryAction: function secondaryAction() {
      return setOpenModal(function (oldState) {
        return !oldState;
      });
    },
    primaryAction: function primaryAction() {
      navigator.clipboard.writeText(JSON.stringify(toast.fullMessage, null, 2));
    },
    primaryActionLabel: "Copiar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-start content-stringify"
  }, /*#__PURE__*/_react.default.createElement("pre", null, JSON.stringify(toast.fullMessage, null, 2)))));
};

ToastNotification.propTypes = {
  toast: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.oneOf(['INFO', 'ERROR', 'SUCCESS', 'WARNING', 'DARK']),
    message: _propTypes.default.string,
    fullMessage: _propTypes.default.shape({})
  })),
  options: _propTypes.default.object
};
ToastNotification.defaultProps = {
  toast: {
    type: 'ERROR',
    message: 'Example Notification',
    fullMessage: null
  },
  options: {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  }
};
var _default = ToastNotification;
exports.default = _default;